/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Every tool on Toolverse — the F1 Fantasy suite, the Percentage Calculators, and the blog — is free to use, and no account is needed for most features. Some advanced F1 Fantasy predictions are part of a Pro plan, but the core tools stay free.`)
};

const es_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Todas las herramientas de Toolverse — la suite de F1 Fantasy, las calculadoras de porcentajes y el blog — son gratuitas, y no necesitas cuenta para la mayoría de las funciones. Algunas predicciones avanzadas de F1 Fantasy forman parte de un plan Pro, pero las herramientas principales siguen siendo gratis.`)
};

const de_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jedes Tool auf Toolverse — die F1-Fantasy-Suite, die Prozentrechner und der Blog — ist kostenlos nutzbar, und für die meisten Funktionen ist kein Konto nötig. Einige fortgeschrittene F1-Fantasy-Vorhersagen sind Teil eines Pro-Plans, aber die Kern-Tools bleiben kostenlos.`)
};

const nl_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elke tool op Toolverse — de F1 Fantasy-suite, de percentagecalculators en de blog — is gratis te gebruiken, en voor de meeste functies is geen account nodig. Sommige geavanceerde F1 Fantasy-voorspellingen horen bij een Pro-abonnement, maar de kerntools blijven gratis.`)
};

const fr_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Chaque outil de Toolverse — la suite F1 Fantasy, les calculatrices de pourcentage et le blog — est gratuit, et aucun compte n'est nécessaire pour la plupart des fonctionnalités. Certaines prédictions avancées de F1 Fantasy font partie d'une offre Pro, mais les outils de base restent gratuits.`)
};

const it_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Ogni strumento su Toolverse — la suite F1 Fantasy, i calcolatori di percentuali e il blog — è gratuito, e per la maggior parte delle funzioni non serve un account. Alcune previsioni avanzate di F1 Fantasy fanno parte di un piano Pro, ma gli strumenti principali restano gratuiti.`)
};

const pt_br2_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Todas as ferramentas do Toolverse — a suíte de F1 Fantasy, as calculadoras de porcentagem e o blog — são gratuitas, e não é preciso conta para a maioria dos recursos. Algumas previsões avançadas de F1 Fantasy fazem parte de um plano Pro, mas as ferramentas principais continuam gratuitas.`)
};

const pt_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Todas as ferramentas do Toolverse — o conjunto F1 Fantasy, as calculadoras de percentagens e o blogue — são gratuitas, e não é preciso conta para a maioria das funcionalidades. Algumas previsões avançadas de F1 Fantasy fazem parte de um plano Pro, mas as ferramentas principais continuam gratuitas.`)
};

const ja_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。Toolverseのすべてのツール — F1ファンタジースイート、パーセント計算機、ブログ — は無料で利用でき、ほとんどの機能にアカウントは不要です。一部の高度なF1ファンタジー予測はProプランに含まれますが、主要ツールは無料のままです。`)
};

const zh_home_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。Toolverse 上的所有工具——F1 Fantasy 套件、百分比计算器和博客——均可免费使用，大多数功能无需注册账户。部分高级 F1 Fantasy 预测属于 Pro 方案，但核心工具始终免费。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_faq1_a", locale)
	if (locale === "en") return en_home_faq1_a(inputs)
	if (locale === "es") return es_home_faq1_a(inputs)
	if (locale === "de") return de_home_faq1_a(inputs)
	if (locale === "nl") return nl_home_faq1_a(inputs)
	if (locale === "fr") return fr_home_faq1_a(inputs)
	if (locale === "it") return it_home_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_home_faq1_a(inputs)
	if (locale === "pt") return pt_home_faq1_a(inputs)
	if (locale === "ja") return ja_home_faq1_a(inputs)
	return zh_home_faq1_a(inputs)
};